import moment from 'moment'
import 'moment-timezone'
import settings from 'popups/Settings'

export const format12Hours = (date: Date | moment.Moment, region?: string): string => {
  const time = moment.tz(date, region || moment.tz.guess())

  const locale = settings.getValue('general').locale as string
  const timeStr = Intl.DateTimeFormat(locale, {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).format(time.toDate())

  if (locale.startsWith('ja')) {
    // 일본어의 경우 0시를 12시로 변경.
    // 10:00 대응으로 정규식 사용.
    const match = timeStr.match(/((午前|午後)0:)/)
    if (match) {
      return timeStr.replace('0:', '12:')
    }
  }

  return timeStr
}

export const format24Hours = (date: Date | moment.Moment, region?: string): string => {
  const time = moment.tz(date, region || moment.tz.guess())
  const hours = time.hour().toString().padStart(2, '0')
  const minutes = time.minute().toString().padStart(2, '0')

  return `${hours}:${minutes}`
}
